export default __webpack_public_path__ + "static/media/1934.af77d979.png";